/**
 * Capitalises the first character of a string.
 * @param str - The string to capitalise.
 * @returns A string with the first character capitalised, or an empty string if str is invalid.
 */
export const capitaliseFirstChar = (
  input: string | null | undefined,
): string => {
  if (!input) return "";

  return input.charAt(0).toUpperCase() + input.slice(1);
};
